import { frontendURL } from '../../../helper/URLHelper';
import PainelPrincipal from './PainelPrincipal.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/painel-principal'),
      name: 'painel_principal',
      meta: {
        permissions: ['administrator'],
      },
      component: PainelPrincipal,
    },
  ],
};
